export enum CompetitionTypesEnum { // Here we can control order in list where we use it
  FOOTBALL = 1,
  BASKETBALL = 2,
  HANDBALL = 3,
  HOCKEY = 4,
  VOLLEYBALL = 5,
  TENNIS = 6,
  WATERPOLO = 7,
  SPECIAL = 8,
  BASEBALL = 9,
  FANTASY = 10,
  NFL = 11,
  FUTSAL = 12,
  RUGBY = 13,
  SNOOKER = 14,
  BOXING = 15,
  CRICKET = 16,
  DARTS = 17,
  ESPORTS = 18,
  TABLETENNIS = 19,
  BADMINTON = 20,
  FORMULA1 = 21,
  CYCLING = 22,
  MOTOGP = 23,
  MMA = 24,
  GOLF = 25,
  CHESS = 26,
  ATHLETICS = 27,
  WINTERGAMES = 28
}






